import React from "react";
// qid is the node id from the drupal content type
// choices is the array of choices for the radio buttons
// onChoice is the function that will handle the radio opton
// NOTE: technically choice.choice_target can have multiple values BUT NOT for the prompt; use the target[0] as the indext to next page
const Prompts = ({ onChoice, choices, qid }) => {
  return (
    <div className="promptBox">
      {choices.map(
        (choice, index) =>
          choice.choice_prompt && (
            <div className="checkbox-container" key={qid + index}>
              <input
                name={qid} // identify this group of buttons so we allow only once choice
                type="radio"
                value={choice.choice_target[0]}
                className="form-radio"
                onChange={() => onChoice(choice.choice_target[0])}
              />
              <label className="radioLabel">{choice.choice_prompt}</label>
            </div>
          )
      )}
    </div>
  );
};

export default Prompts;
